import React, { useState } from "react";
import PropTypes from "prop-types";
// import FormGroup from './FormGroup'

const Form = (props) => {
  const [text, setText] = useState("");

  const onChange = (e) => setText(e.target.value);
  const onSubmit = (e) => {
    e.preventDefault();
    document.querySelector('.grades-form').reset();
    props.splitGrades(text);
  };
  return (
    <form className="grades-form" onSubmit={onSubmit}>
      <div className="form-group">
        <label htmlFor="input_grades">Paste Grades Here:</label>
        <textarea
          onChange={onChange}
          className="form-control"
          id="input_grades"
          rows="10"
        ></textarea>
        <input
          type="submit"
          className="btn btn-primary mb-2 my-2 mx-auto d-block"
          value="Enter"
        ></input>
      </div>
    </form>
  );
};

Form.propTypes = {};

export default Form;
